module.exports = __webpack_public_path__ + "img/goods8_6.8d05e240.jpg";